export default __webpack_public_path__ + "static/media/gas.4c8bdec9.jpg";